module.exports = __webpack_public_path__ + "img/googlePlay.ed4a6af6.svg";